module.exports = __webpack_public_path__ + "media/united.a06c6fd2.mp4";